var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 13.9999L5.08667 10.9125M5.09 10.9092L3.23667 9.05587C2.60067 8.42054 3.24067 7.05854 4.11 7.00387C4.89533 6.95387 6.71333 7.23854 7.318 6.63387L8.978 4.97387C9.38933 4.56187 9.128 3.64054 9.10133 3.13254C9.06267 2.4552 10.14 1.61854 10.7113 2.18987L13.8093 5.28854C14.3827 5.86054 13.5427 6.93454 12.8673 6.89854C12.3593 6.87187 11.4373 6.61054 11.0253 7.02187L9.36533 8.68187C8.76133 9.28654 9.04533 11.1039 8.996 11.8892C8.94133 12.7592 7.57933 13.3992 6.94267 12.7625L5.09 10.9092Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pin.aa18fa67.svg";
export { ForwardRef as ReactComponent };